import React, { FC, useMemo } from 'react';
import { Section } from 'omni-package-react-core';
import { useTranslation } from 'react-i18next';
import { TimeFormat } from 'ia-react-core';
import { PersonalInformation } from '../../interfaces/PersonalInformation';
import { StyledP } from './BirthDate.styles';

export interface BirthDateProps {
  personalInfo: PersonalInformation;
}
const BirthDate: FC<BirthDateProps> = ({ personalInfo }) => {
  const { t } = useTranslation('PersonalInformationsTile');
  const infos = useMemo(() => ({ ...personalInfo?.identification }), [personalInfo]);

  if (!personalInfo || !personalInfo.identification) return null;
  if (personalInfo.identification.birthDate === null) return null;
  if (personalInfo.identification.behaviours.showDateOfBirth === false) return null;

  return (
    <Section name={t('birthDateLabel')}>
      <StyledP><TimeFormat time={new Date(infos.birthDate)} /></StyledP>
    </Section>
  );
};
export default BirthDate;
